import { render, staticRenderFns } from "./matchAlgorithmConfig.vue?vue&type=template&id=1adda036"
import script from "./matchAlgorithmConfig.vue?vue&type=script&lang=js"
export * from "./matchAlgorithmConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports